// extracted by mini-css-extract-plugin
export var content = "product-module--content--PJgB1";
export var details = "product-module--details--UitCQ";
export var format = "product-module--format--l9419";
export var hMdScreen = "product-module--hMdScreen---zDa6";
export var hScreen = "product-module--hScreen--yA77Q";
export var pictureContain = "product-module--pictureContain--8pHfY";
export var pictureCover = "product-module--pictureCover--7SJ93";
export var productImage = "product-module--product-image--YQnhJ";